import handleFetchResponse from 'services/utils/handleFetchResponse';
import firebase from 'firebase/app';
import { handleHikeError } from 'services/hitchit';
import { HikeError } from 'services/hitchit/types/hike/HikeError';

export default async function authenticatedFetcher(url: string, user: firebase.User): Promise<any> {
  const idToken = await user.getIdToken();

  const response = await fetch(`${process.env.NEXT_PUBLIC_AUTH_URI}${url}`, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + idToken,
    },
  });

  return await handleFetchResponse(response);
}

export async function authenticatedPoster(
  url: string,
  user: firebase.User,
  body: Record<string, any>
): Promise<any> {
  const idToken = await user.getIdToken();

  const response = await fetch(`${process.env.NEXT_PUBLIC_AUTH_URI}${url}`, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + idToken,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await handleFetchResponse(response);

  try {
    return { data, isLoading: false, isError: false };
  } catch (e) {
    return handleHikeError(e as HikeError);
  }
}
